import { ArrowLeft } from "./icons";
import "./style.css";

/**
 * Page shell for standalone settings routes — the deep-linkable counterpart to
 * the header menu's drill-down panel. Both render the same rows from
 * menuConfig; see docs/navigation-redesign-plan.md §3.3.
 *
 * Background comes from BackgroundWrapper in AppRoutes, never from here.
 */
function SettingsPageShell({ title, onBack, children }) {
  return (
    <div className="aris-settings-list aris-settings-page">
      <div className="aris-settings-page__header">
        {onBack && (
          <button
            type="button"
            className="aris-settings-page__back"
            onClick={onBack}
            aria-label="Go back"
          >
            <ArrowLeft />
          </button>
        )}
        <h1 className="aris-settings-page__title">{title}</h1>
      </div>
      <div className="aris-settings-page__body">{children}</div>
    </div>
  );
}

export default SettingsPageShell;
